import { indexData } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题索引</h2>
          <p className="text-sm text-foreground-500 mt-2">按频道浏览你最感兴趣的内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-5 flex flex-col items-start gap-3 cursor-pointer hover:bg-background-200 transition-colors group"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <div>
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 mt-auto">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}